import React, { useEffect, useState } from 'react';
import utils from '../../../utils';
import CustomInput from '../../../components/customInput';
import CustomButton from '../../../components/customButton';
import API from '../../../services/api';

const CompanyForm = ({ user, accessToken, onSuccess, onError, onLoading }) => {
  const [companyName, setCompanyName] = useState('');
  const [errors, setErrors] = useState({});

  const fields = {
    companyName
  };

  const validation = {
    companyName: [
      { key: 'required', value: true },
      { key: 'min', value: 4 }
    ]
  };

  useEffect(() => {
    Object.entries(fields).forEach(([field, value]) => {
      validateInput(field, value);
    });
  }, [companyName]);

  const validateInput = (field, value) => {
    const rules = validation[field];
    const result = utils.fieldValidation(value, rules);
    setErrors(prev => ({
      ...prev,
      [field]: result.join(', ')
    }));
  };

  const handleConfirm = () => {
    const newCompany = {
      display_name: companyName
    };
    onLoading(true);

    API.createCompany(accessToken, newCompany)
      .then(newCompanyResponse => {
        const newSiteGroup = {
          displayName: `${companyName}'s Site Group`,
          owner_id: user.id
        };
        API.createSiteGroup(newCompanyResponse.id, newSiteGroup, accessToken)
          .then(() => {
            onSuccess();
          })
          .catch(error => {
            onError(`Site group creation failed: ${error.message}`);
          });
      })
      .catch(error => {
        onError(`Company creation failed: ${error.message}`);
      });
  };

  return (
    <>
      <div className="registration-header">
        <h2>New let’s set up your company info</h2>
      </div>
      <div className="registration-form">
        <div className="form-group">
          <div className="row">
            <div className="col">
              <label htmlFor="name">Company*</label>
              <CustomInput
                id="company"
                type="text"
                placeholder="Write Company's name"
                value={companyName}
                isEditable={true}
                onChange={e => {
                  setCompanyName(e.target.value);
                }}
                autoFocus={true}
                errorMessage={errors.companyName}
              />
            </div>
          </div>
        </div>
      </div>
      <CustomButton
        title={'Next'}
        classes="registration-button btn-primary"
        handleClick={handleConfirm}
        // handleClick={() => {
        //   onSuccess();
        //   onLoading(true);
        // }}
        disabled={Object.values(errors).some(msg => msg)}
      />
    </>
  );
};

export default CompanyForm;
